export default "__VITE_ASSET__480a415b__"